import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ABUSE_EMAIL, abuseMailto, reportableLink } from '../lib/abuseReport';
import { usePageTitle } from '../hooks/usePageTitle';
import ui from '../styles/ui.module.css';
import styles from './LegalPage.module.css';
import abuse from './AbusePage.module.css';

export default function AbusePage() {
  const { t } = useTranslation();
  const [link, setLink] = useState('');
  const [details, setDetails] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sentLink, setSentLink] = useState<string | null>(null);
  usePageTitle(t('legal.abuse.title'));

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const cleaned = reportableLink(link);
    if (!cleaned) {
      setError(t('legal.abuse.invalidLink'));
      return;
    }
    setError(null);
    // Show the cleaned link in the field so the reporter sees the key is gone.
    setLink(cleaned);
    setSentLink(cleaned);
    window.location.href = abuseMailto(cleaned, details, t('legal.abuse.emailSubject', { link: cleaned }));
  }

  return (
    <main className={ui.page}>
      <div className={ui.prose}>
        <h1 className={styles.title}>{t('legal.abuse.title')}</h1>
        <p>{t('legal.abuse.lead')}</p>
        <form onSubmit={onSubmit} className={`${ui.panel} ${abuse.form}`}>
          <label className={ui.field}>
            {t('legal.abuse.linkLabel')}
            <input
              type="url"
              required
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder={t('legal.abuse.linkPlaceholder')}
              autoComplete="off"
              aria-describedby={error ? 'abuse-fragment-note abuse-error' : 'abuse-fragment-note'}
              aria-invalid={error ? true : undefined}
            />
          </label>
          <p id="abuse-fragment-note" className={ui.hint}>
            {t('legal.abuse.fragmentNote')}
          </p>
          <label className={ui.field}>
            {t('legal.abuse.detailsLabel')}
            <textarea value={details} onChange={(e) => setDetails(e.target.value)} rows={5} />
          </label>
          {error && (
            <p role="alert" id="abuse-error" className={ui.error}>
              {error}
            </p>
          )}
          <button type="submit" className={ui.button}>
            {t('legal.abuse.submit')}
          </button>
        </form>
        {sentLink && (
          <p role="status">
            {t('legal.abuse.ready', { link: sentLink })} <a href={`mailto:${ABUSE_EMAIL}`}>{ABUSE_EMAIL}</a>
          </p>
        )}
      </div>
    </main>
  );
}
